module.exports = __webpack_public_path__ + "static/media/AVI_8170_rsz.05c0808d.jpg";